import { OrgData } from "@shared/types";

import { authPost } from "../auth/auth";

export const createDeployment = async (
  deployment_name: string,
  source_type: string,
  source_id?: string
): Promise<OrgData> => {
  return authPost<
    { deployment_name: string; source_type: string; source_id?: string },
    { deployment: OrgData }
  >("/api/agent/deployments", { deployment_name, source_type, source_id }).then(
    (response) => {
      return response.deployment;
    }
  );
};
